__webpack_require__.p = "https://dev.vizvedok.hu/";